var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current",attrs:{"viewBox":"0 0 4 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.99382e-07 4C3.13124e-07 1.79086 1.79086 -3.13124e-07 4 -6.99382e-07L4 21C1.79086 21 3.35863e-06 19.2091 2.97237e-06 17L6.99382e-07 4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }